import App from "./App";
import getUser from "../store/user/actions/getUser";

export default {
    component: App,
    loadData: ({ dispatch }: any) => dispatch(getUser()),
};
